import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { FileText, Calendar, CloudRain, CheckSquare, Users } from 'lucide-react';
export function ProductIncludes() {
  const items = [{
    icon: FileText,
    title: "PDF completo 'Rodilla Sin Miedo'",
    desc: 'La guía central con toda la teoría y práctica.'
  }, {
    icon: Calendar,
    title: 'Plan de 14 días',
    desc: 'Día por día, sin adivinanzas.'
  }, {
    icon: CloudRain,
    title: 'Modo Día Malo',
    desc: 'Protocolo especial para cuando amanecés rígido/a.'
  }, {
    icon: CheckSquare,
    title: 'Checklist imprimible',
    desc: 'Para seguir tu progreso en papel.'
  }, {
    icon: Users,
    title: 'Módulo 60+ / Artrosis',
    desc: 'Ritmo, constancia y rango seguro adaptado.'
  }];
  return <Section background="warm" id="includes" data-id="element-293">
      <FadeIn data-id="element-294">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-295">
          Qué incluye exactamente
        </h2>

        <div className="grid gap-6 mb-12" data-id="element-296">
          {items.map((item, index) => <div key={index} className="flex items-start p-4 md:p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-297">
              <div className="bg-[#D8F3DC] p-3 rounded-lg mr-4 md:mr-6 flex-shrink-0" data-id="element-298">
                <item.icon className="h-6 w-6 text-[#1B4332]" data-id="element-299" />
              </div>
              <div data-id="element-300">
                <h3 className="font-bold text-lg text-[#1A1A1A] mb-1" data-id="element-301">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-302">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-303">
          <Button size="lg" scrollTo="checkout" data-id="element-304">
            Acceder a todo el material
          </Button>
        </div>
      </FadeIn>
    </Section>;
}